import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X6PageStore} from '../X6PageStore';

@observer
export class EditPushableBlockControls extends React.Component<{ store: X6PageStore }> {
  render() {
    const {store} = this.props;

    if (store.editPushableBlock === null)
      return null;

    const editPushableBlock = store.editPushableBlock;
    const isPending = editPushableBlock.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeEdit}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={editPushableBlock.save} align="right"/>
    </>);
  }
}
